//import logo from './logo.svg';
import './Header.css';
import {Link, Navigate, useNavigate} from 'react-router-dom';
import { useState, useEffect, useRef, useCallback } from 'react';
//import logocham from './Logopequeno.png';
//import regr from './regr.png';
import axios, { Axios } from 'axios';
import menu from './Menub.webp';
import Logoicono from '../Componentes/logosvg2';
import Notificaciones from '../Componentes/notificaciones';
import sonidonot from './notificacionsound.mp3';

function Header() {

  axios.defaults.withCredentials = true;
  const [isOpen, setIsOpen] = useState(false);
  const [notsopen, setnotsopen] = useState(false);
  const [NuevaNot, setNuevaNot] = useState(false);
  const [notsobtenidas, setnotsobtenidas] = useState(['']);
  const [LastCheck, setLastCheck] = useState(null);

  const navigate = useNavigate();
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

const Campana2 = ()  => {
  return(<>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" className={NuevaNot===false ? 'logocampana' : 'logocampanauso'} viewBox="0 0 48 48">
      <path d="M40.62,28.34l-.87-.7A2,2,0,0,1,39,26.08V18A15,15,0,0,0,26.91,3.29a3,3,0,0,0-5.81,0A15,15,0,0,0,9,18v8.08a2,2,0,0,1-.75,1.56l-.87.7a9,9,0,0,0-3.38,7V37a4,4,0,0,0,4,4h8.26a8,8,0,0,0,15.47,0H40a4,4,0,0,0,4-4V35.36A9,9,0,0,0,40.62,28.34ZM24,43a4,4,0,0,1-3.44-2h6.89A4,4,0,0,1,24,43Zm16-6H8V35.36a5,5,0,0,1,1.88-3.9l.87-.7A6,6,0,0,0,13,26.08V18a11,11,0,0,1,22,0v8.08a6,6,0,0,0,2.25,4.69l.87.7A5,5,0,0,1,40,35.36Z"/>
</svg>
  </>)
}

const [lastTimestamp, setLastTimestamp] = useState(null);
useEffect(() => {
  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_HTTPS}/api/establecimientos/nots`);
        const notifications = response.data;
        if (notifications.length > 0) {
          setNuevaNot(true);
        }
        const newLastTimestamp = notifications[0]?.Timestamp || null; 

        if (newLastTimestamp > lastTimestamp) {
          console.log('Nueva notificacion');
          const audio = new Audio(sonidonot);
          audio.play().catch((error) => console.log('Error al reproducir el sonido:', error));
        }
        setnotsobtenidas(notifications);
        setLastTimestamp(newLastTimestamp);
    } catch (error) {
      if (error.response && error.response.data.code === 'UNAUTHORIZED') {
        console.log('Sesión finalizada, recargando...');
        window.location.reload();
      } else {
        console.error('Error al obtener las Notificaciones:', error);
      }
    }
  };
  const intervalId = setInterval(fetchNotifications, 30000);
  fetchNotifications();
  return () => clearInterval(intervalId);
}, [lastTimestamp]);

const abrirnots = () =>{
  setnotsopen(!notsopen);
}

const Cerrarsesion = () =>{
  axios.post(`${process.env.REACT_APP_HTTPS}/api/user/logout`)
  .then((res) => {
    if (res){
      console.log('Cerrar sesion');
      window.location.replace('/');
    }
    else {console.log('No se puede cerrar la sesion')}
  }).catch((error) => {
    console.error('Error al cerrar sesion:', error);
  });
}

  return (
    <div className='Header'>
      {/* Menu desplegable de la izquierda */}
      {isOpen ? (<div className='outnot' onClick={toggleMenu}></div>):(<></>)}
    <div className={`sidebar ${isOpen ? 'active' : ''}`}>
      <Link to="/" state={{from: 'any'}} onClick={toggleMenu} className='Link'>Manejo de canchas</Link>
      <Link to="/Reservas" onClick={toggleMenu} className='Link'>Todas las reservas</Link>
      <Link to="/Ofertas" onClick={toggleMenu} className='Link'>Ofertas</Link>
      {/** <Link to="/ReservasPrueba" onClick={toggleMenu} className='Link'>Pruebas reservas</Link>*/}
      <Link to="/EditarEst" onClick={toggleMenu} className='Link'>Editar establecimiento</Link>
      <Link to="/Credenciales" onClick={toggleMenu} className='Link'>Usuario y contraseña</Link>
      <Link to="/Informacion" onClick={toggleMenu} className='Link'>Términos y Condiciones</Link>
      <h2 onClick={Cerrarsesion} className='cerrarsesion'>Cerrar sesión</h2>
  </div>
  {/* Barra superior */}
    <div className='barraheader'>
      <div className="col1">
        <img src={menu} className='ico1' onClick={toggleMenu} alt='menu'/>
      </div>
      <div className='col2'>
        <Link to="/" state={{from: 'any'}} className='Linkh' onClick={isOpen ? toggleMenu : undefined}>
          <div className='logopequeno'><Logoicono/></div>
          <p className='txttitulo'>Chamuscón</p>
        </Link>
      </div>
      <div className="ico2" alt="Notificaciones" onClick={abrirnots}>
        <Campana2/>{NuevaNot===false ? (<></>) : (<div className='puntorojo'></div>)}
           {/** <Campana Classnuevanot={NuevaNot}/> {NuevaNot===false ? 'logocampana' : 'logocampanauso'} */}
      </div>
    </div>
    <Notificaciones abrir={notsopen} Notsobtenidas={notsobtenidas} abcer={abrirnots}/>
  </div>
  );
}

export default Header;